import { DataFormProps } from './typeForm';

export function verifyIfCanSave(data: DataFormProps, handleNotify: any) {
	if (data.name === '') {
		handleNotify('Nome obrigatório!', 'error');
		return false;
	}

	return true;
}
